













import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { IndexBar, IndexAnchor, Cell, Search } from "vant";
import dataShare from "../dataShare";

@Component({
  name: "chooseContraryReason",
  components: {
    [IndexBar.name]: IndexBar,
    [IndexAnchor.name]: IndexAnchor,
    [Cell.name]: Cell,
    [Search.name]: Search,
  },
})
export default class extends Vue {
  dataShare = dataShare;
  keywords = "";

  get options() {
    return this.dataShare.contraryReasons;
  }

  select(value: any) {
    let contrary = this.dataShare.contraryReason as any;
    contrary.CauseID = value.TextID;
    contrary.CauseName = value.TextName;
    contrary.FeatureCode = value.FeatureCode;

    // Vue.set(contrary, "CauseName", selectReason.TextName);
    // contraryReason.TextID = value.TextID;
    // contraryReason.TextName = value.TextName;
    // contraryReason.TextID = value.;
    this.back();
  }

  back() {
    history.back();
  }

  // get ServiceType() {
  //   return _.upperFirst(this.$route.query.ServiceType + "Service");
  // }
  // get TravelReasonType() {
  //   return this.$store.getters.categorys.types.TravelReasonType;
  // }
  // get ServiceTypeTypes() {
  //   return this.$store.getters.categorys.types.ServiceType;
  // }
  // get Reason() {
  //   return this.$route.query.Reason;
  // }
  // mounted() {
  //   this.__init();
  // }
  // __init() {
  //   let __self = this;
  //   btripServcice.getBtripTexts(__self.ServiceTypeTypes[__self.ServiceType]).then(function(json) {
  //     if (json.data.isSucc) {
  //       for (let j = 0; j < json.data.result.length; j++) {
  //         var element = json.data.result[j];
  //         if (element.TextType == __self.TravelReasonType.PolicyCause) {
  //           __self.TravelReasons.push(element);
  //         }
  //       }
  //     }
  //   });
  // }

  // selectTravelReason(TravelReason) {
  //   let __self = this;
  //   TravelReason.Reason = __self.Reason;
  //   $utils.Storage[__self.Reason] = JSON.stringify(TravelReason);
  //   history.back();
  // }
}
